<template>
  <div>
    <p class="ai_title_new" style="margin-left: 40px">“智能生成”_产品集</p>
    <ul class="word_list flex">
      <li @click="routePush(item.id)" v-if="$route.meta != item.title" v-for="(item, index) in list" :key="index">
        <img :src="item.imgUrl" alt="">
        <p>{{ item.title }}</p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  mounted() {
  },
  data() {
    return {
      list: [
        {
          id: 0,
          imgUrl: require('@/assets/wordOp/0.png'),
          title: '个人简介',
          path: '/IndividualResume'
        },
        {
          id: 1,
          imgUrl: require('@/assets/wordOp/1.png'),
          title: '广告语',
          path: '/slogan'
        },
        {
          id: 2,
          imgUrl: require('@/assets/wordOp/2.png'),
          title: '文稿润色',
          path: '/manuscriptPolishing'
        },
        // {
        //   id: 3,
        //   imgUrl: require('@/assets/wordOp/4.png'),
        //   title: '错别字修改',
        //   path: '/wrongly',
        // },
        {
          id: 14,
          imgUrl: require('@/assets/wordOp/14.png'),
          title: '一点成诗',
          path: '/verse',
        },
        {
          id: 4,
          imgUrl: require('@/assets/wordOp/4.png'),
          title: '记叙文',
          path: '/narration',
        },
        {
          id: 5,
          imgUrl: require('@/assets/wordOp/5.png'),
          title: '产品简介',

          path: '/productResume',
        },
        {
          id: 6,
          imgUrl: require('@/assets/wordOp/6.png'),
          title: '短视频脚本',
          path: '/shortVideo',
        },
        {
          id: 7,
          imgUrl: require('@/assets/wordOp/7.png'),
          title: '议论文',
          path: '/esay',
        },
        {
          id: 8,
          imgUrl: require('@/assets/wordOp/8.png'),
          title: '祝福语',

          path: '/greeting'
        },
        {
          id: 9,
          imgUrl: require('@/assets/wordOp/9.png'),
          title: '文稿改写',
          path: '/manuscriptRewriting',
        },
        {
          id: 10,
          imgUrl: require('@/assets/wordOp/10.png'),
          title: '企业简介',

          path: '/EnterpriseProfile'
        },
        {
          id: 11,
          imgUrl: require('@/assets/wordOp/11.png'),
          title: '纪录片脚本',
          path: '/documentary',
        },
        {
          id: 12,
          imgUrl: require('@/assets/wordOp/2.png'),
          title: '标题提炼',
          path: '/titleExtraction',
        },
        {
          id: 15,
          imgUrl: require('@/assets/wordOp/7.png'),
          title: '营销软文',
          path: '/article',
        },
        {
          id: 16,
          imgUrl: require('@/assets/wordOp/7.png'),
          title: '说明书',
          path: '/instructions',
        },
        {
          id: 17,
          imgUrl: require('@/assets/wordOp/7.png'),
          title: 'AI小说/歌词',
          path: '/novel',
        },
        {
          id: 18,
          imgUrl: require('@/assets/wordOp/18.png'),
          title: '商业计划书',
          path: '/business',
        },
        {
          id: 19,
          imgUrl: require('@/assets/wordOp/19.png'),
          title: 'PPT内容框架',
          path: '/ppt',
        },
        {
          id: 20,
          imgUrl: require('@/assets/wordOp/20.png'),
          title: 'AI策划方案',
          path: '/activities',
        },
        {
          id: 21,
          imgUrl: require('@/assets/wordOp/21.png'),
          title: 'AI发言稿',
          path: '/speechdraft',
        },
        {
          id: 22,
          imgUrl: require('@/assets/wordOp/22.png'),
          title: 'AI演讲稿',
          path: '/speechtext',
        },
        {
          id: 23,
          imgUrl: require('@/assets/wordOp/23.png'),
          title: '小红书文案',
          path: '/word_redbook',
        },
        {
          id: 24,
          imgUrl: require('@/assets/wordOp/24.png'),
          title: 'AI声明',
          path: '/ai_statement',
        },
        {
          id: 25,
          imgUrl: require('@/assets/wordOp/25.png'),
          title: 'AI商评',
          path: '/business_review',
        },
        {
          id: 26,
          imgUrl: require('@/assets/wordOp/26.png'),
          title: 'AI访谈',
          path: '/interview',
        }, {
          id: 28,
          imgUrl: require('@/assets/ai/18.png'),
          title: '律师函',
          path: '/lawyer'
        },
        {
          id: 29,
          imgUrl: require('@/assets/ai/21.png'),
          title: '起诉书',
          path: '/prosecute',
        },
        {
          id: 30,
          imgUrl: require('@/assets/ai/20.png'),
          title: '版权侵权告知书',
          path: '/tort'
        },

        {
          id: 31,
          imgUrl: require('@/assets/ai/13.png'),
          title: 'AI绘画',
          path: '/paint'
        },
        {
          id: 32,
          imgUrl: require('@/assets/ai/15.png'),
          title: '黑白图像上色',
          path: '/blackWhite'
        },
        {
          id: 33,
          imgUrl: require('@/assets/ai/16.png'),
          title: '图片风格转换',
          path: '/transImg'
        },
        {
          id: 34,
          imgUrl: require('@/assets/ai/22.png'),
          title: '图片背景生成',
          path: '/image_matting'
        },
        {
          id: 35,
          imgUrl: require('@/assets/ai/23.png'),
          title: '一键抠图',
          path: '/change_back'
        },
        {
          id: 36,
          imgUrl: require('@/assets/ai/24.png'),
          title: 'AI智能海报',
          path: '/placard',
        },
        {
          id: 37,
          imgUrl: require('@/assets/ai/28.png'),
          title: 'AI视频合成',
          path: '/videoCompositing',
        },
      ],
      fullscreenLoading: false
    }
  },
  methods: {
    routePush(id) {
      this.list.forEach(item => {
        if (item.id == id) {
          return this.$router.push(item.path)
        }
      })
    }
  },
}
</script>

<style lang=scss scoped>
.word_list {
  max-width: 410px;
  max-height: 790px;
  margin-top: 50px;
  flex-wrap: wrap;
  overflow: auto;

  &::-webkit-scrollbar {
    background-color: rgb(62, 160, 254);
    width: 10px;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #fff;
    width: 10px;
    border-radius: 10px;
  }

  li {
    margin: 0 1rem 1rem 0;
    width: 10rem;
    height: 10rem;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    text-align: center;
    border-radius: 1.25rem;
    border: 0.25rem solid rgba(255, 255, 255, 1);
    justify-content: center;
    transition: 0.3s;
    cursor: pointer;
    margin-bottom: 1rem;

    &:hover {
      background: rgba(196, 227, 255, 1);
    }

    img {
      width: 4rem;
      display: block;
      margin: 0 auto;
    }

    p {
      font-size: 1.2rem;
      color: rgba(51, 51, 51, 1);
    }
  }
}
</style>